/* Copyright (c) 2020-present CloudIO Inc */

import { useEffect } from 'react';

const _mountedComponents: Record<string, number> = {};

export function useComponentTracker(itemType: string) {
  useEffect(() => {
    _mountedComponents[itemType] = (_mountedComponents[itemType] ?? 0) + 1;
    return () => {
      _mountedComponents[itemType] = (_mountedComponents[itemType] ?? 0) - 1;
    };
  }, [itemType]);
}

export function getMountedCount(itemType: string): number {
  return _mountedComponents[itemType] ?? 0;
}

export function getTotalMountedCount(): number {
  return Object.values(_mountedComponents).reduce((t, v) => t + v, 0);
}
